export function dataUriToFile(dataUri, fileName) {
  // Extract the Base64 part
  let base64String = dataUri?.split(",")[1];

  // Add padding if needed
  while (base64String.length % 4) {
    base64String += "=";
  }

  // Decode the Base64 string
  const binaryString = atob(base64String);

  // Create a Uint8Array from the binary string
  const uint8Array = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    uint8Array[i] = binaryString.charCodeAt(i);
  }

  // Create a File from the Uint8Array
  const file = new File([uint8Array], fileName || "image.png", {
    type: "image/png",
  });

  return file;
}

export function generateRandomName() {
  const letters = "abcdefghijklmnopqrstuvwxyz";
  let randomName = "";

  for (let i = 0; i < 10; i++) {
    const randomIndex = Math.floor(Math.random() * letters.length);
    randomName += letters.charAt(randomIndex);
  }

  return randomName;
}

export async function imageUrlToDataUri(imageUrl: string): Promise<string> {
  // console.log("imageUrlToDataUri", imageUrl);
  const response = await fetch(imageUrl);
  const blob = await response.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

export async function dataUriToFileFromUrl(
  imageUrl: string,
  fileName?: string
): Promise<File> {
  const dataUri = await imageUrlToDataUri(imageUrl);
  return dataUriToFile(dataUri, fileName);
}
